module.exports = __webpack_public_path__ + "static/media/v_logo_vip-skinceuticals.8186bb9e.png";